var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var UploadSignedDocumentForm = require("./upload-signed-document-form-view");
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var DocumentsCollection = require('../../collections/documents-collection');

var UploadSignedDocumentView = Marionette.View.extend({
    template: require('../../templates/documents/upload-signed-document-view.html'),

    regions: {
        patientSelect: '#patient-select',
        uploadForm: '#upload-form',
        confirmationModal: '#confirmation-modal'
    },

    childViewEvents: {
        'suggestor:selected:patient': "onPatientSelected",
        'signed:document:uploaded': "onDocumentUploaded",
        'action:confirmed': 'onSignSignedDocumentConfirmed'
    },

    ui: {
        barcode: "#barcode",
        search: '#search-documents',
        docs: "#fount-docs"
    },

    events: {
        'keyup @ui.barcode': 'onChangeBarcode',
        'click @ui.search': 'searchDocuments'
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
    },


    onRender: function () {
        window.document.title = "Upload signed documents";
        var that = this;
        that.showPatientsSelect();

        this.confirmationModal = new YesNoConfirmationModal({
            tag: 'sign-signed-doc',
            message: "This document is already signed within the portal. Would you like to replace it with a new document?"
        });
        this.showChildView('confirmationModal', this.confirmationModal);
    },

    showPatientsSelect: function () {
        var that = this;

        that.showChildView('patientSelect', new RemoteSuggesterView({
            multiSelect: false,
            maxNumberOfElements: 20,
            url: '/api/person/preview?page-size=' + 20
                + '&sortby=name&like_name=~~~&object_mergeable=false&object_isPatient=true',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object;
                });
            },
            getIdFn: function (element) {
                return element.id;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Patient",
            tag: 'patient',
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            }
        }));
    },

    enableDisableSearch: function () {
        if (this.ui.barcode.val() || this.selectedPatient)
            this.ui.search.removeAttr("disabled");
        else
            this.ui.search.attr("disabled", true);
    },

    onChangeBarcode: function (e) {
        this.enableDisableSearch();
    },

    onPatientSelected: function (selected) {
        this.selectedPatient = selected;
        this.enableDisableSearch();
    },

    onDocumentUploaded: function (doc) {
        Backbone.history.navigate('/document/' + doc.id, {trigger: true});
    },

    searchDocuments: function () {
        var that = this;
        that.detachChildView('uploadForm');

        var params = [
            {key: 'sortby', value: 'createdTime'},
            {key: 'sortdir', value: 'DESC'},
            {key: 'object_type', value: 'pdf'},
            {key: 'object_status', value: 'IN_REVIEW'},
            {key: 'object_status', value: 'UNDER_REVIEW'},
            {key: 'object_status', value: 'SIGNED'}
        ];

        if (this.ui.barcode.val())
            params.push({key: 'object_externalIds_in', value: Constants.barCodePrefix + that.ui.barcode.val()});
        if (this.selectedPatient)
            params.push({key: 'object_patientId', value: that.selectedPatient.id});

        var documentsCollection = new DocumentsCollection([], {
            params: params
        });
        documentsCollection.fetch({
            success: function () {
                var rows = documentsCollection.map(function (model) {
                    return model.attributes;
                });
                that.documents = rows;
                that.renderDocuments(rows);
            },
            error: function (e) {
                that.logError(e);
            }
        });
    },

    renderDocuments: function (rows) {
        var that = this;

        if (rows.length == 0) {
            this.ui.docs.html("No documents");
            return;
        }

        var listStart = '<ul class="list-group">';
        var listEnd = "</ul>";
        var listContent = rows.map(function (row) {
            var checkbox = '<input type="checkbox" id="' + row.id + '" class="doc-check"/>';
            var linkToViewDoc = '<a href="/api/document/view/' + row.id
                + '" target="_blank" class="view"><span class="clickable glyphicon glyphicon-eye-open"/></a>';
            var linkToDoc = '<a href="/#document/' + row.id + '" target="_blank">' + row.name + '</a>';
            var docStatus = that.utils.getDocumentStatus((row.object || {}).status);
            return '<li class="list-group-item">' + linkToViewDoc + '&nbsp;' + checkbox + '&nbsp;' + linkToDoc + " (" + docStatus + ") " + "</li>"
        }).join("");

        this.ui.docs.html(listStart + listContent + listEnd);

        $(function () {
            $('.doc-check').click(function (e) {
                var id = e.target.id;
                $('.doc-check').each(function (i, el) {
                    if (el.id !== id) {
                        $(this).prop('checked', false);
                    }
                });
                that.renderForm(id, e.target.checked);
            });
        });
    },

    renderForm: function (documentId, selected) {
        var selectedDocument = _.findWhere(this.documents, {id: documentId});
        this.detachChildView('uploadForm');

        if (selected) {
            this.selectedDocument = selectedDocument;
            if (selectedDocument.object.status !== "SIGNED")
                this.showChildView("uploadForm", new UploadSignedDocumentForm({document: selectedDocument}));
            else {
                this.confirmationModal.show();
            }
        }
    },

    onSignSignedDocumentConfirmed: function (data) {
        if (data.tag === 'sign-signed-doc' && data.result == true) {
            this.showChildView("uploadForm", new UploadSignedDocumentForm({document: this.selectedDocument}));
        } else {
            this.confirmationModal.hide();
            $('#' + this.selectedDocument.id).prop('checked', false);
        }
    }
});

module.exports = UploadSignedDocumentView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/upload-signed-document-view.js
// module id = 442
// module chunks = 0